module.exports = __webpack_public_path__ + "img/pro_stop.71a20522.png";